import { computed, inject, Injectable } from "@angular/core";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { PassApiService } from "./pass-api.service";
import { PassState, PassStoreService } from "./pass-store.service";
import { Pass } from "../../models/pass.model";
import {
  Untrack,
  UpdateStatus,
} from "../../../../shared/store/utils/store-utils.service";

@Injectable({
  providedIn: "root",
})
export class PassFacadeService extends EntityFacadeService<
  Pass,
  PassApiService,
  PassState
> {
  constructor() {
    const api = inject(PassApiService);
    const store = inject(PassStoreService);
    super(api, store);
    this.store.initStatus(PassFacadeService);
  }

  @Untrack
  @UpdateStatus
  async inheritPass(denomination: string, id: string) {
    const pass = await this.api.inheritPass(denomination, id);
    this.store.upsertOne(pass);
    return pass;
  }

  currentPass = computed(() => {
    const currentPassId = this.getState().currentPassId();
    if (this) return this.elements().find((e) => e().id === currentPassId)?.();
  });

  hasAccessTo(access: string) {
    return computed(() => {
      const p = this.currentPass();
      if (!p) {
        return false;
      }
      if (access === "infos") {
        return !!(p.specifs || p.tiers || p.lignes);
      }
      if (access === "prod_menu") {
        return !!(p.prod || p.plannif_prod || p.stats_prod);
      }
      if (access === "commande_menu") {
        return !(p.commandes || p.commandesClient);
      }
      return !!p[access];
    });
  }
}
